import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';

interface OrderLabelsApiReturn {
    printShippingLabels: (order_id: number) => Promise<{ url?: string }>
    voidLabels: (order_id: number) => Promise<void>
    uploadShippingLabel: (order_id: number, file: File) => Promise<void>
}

export default (axios: AxiosInstance = baseAxios): OrderLabelsApiReturn => ({
    printShippingLabels: async (order_id: number): Promise<{ url?: string }> => {
        const response = await axios.post<{ url?: string }>(`/api/orders/${order_id}/printShippingLabels`);

        return response.data;
    },

    voidLabels: async (order_id: number): Promise<void> => {
        await axios.post(`/api/orders/${order_id}/voidLabels`);
    },

    uploadShippingLabel: async (order_id: number, file: File): Promise<void> => {
        const data = new FormData();
        data.append('file', file);

        await axios.post(`/api/orders/${order_id}/uploadShippingLabel`, data);
    },
});
